import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CompanyDetail } from '../../Models/Models/Company/CompanyDetail';

declare var IS_RUNNING_IN_APP_POOL;

export class CompanyViewClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(companyCode: string): Promise<CompanyDetail, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/CompanyView/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { companyCode: companyCode }

    return AjaxWrapper.get<CompanyDetail, any>(url, data);
  }
}

